import {
  toAbout,
  toCareers,
  toFAQ,
  toFundingPools,
  toHome,
  toPeople,
  toPortfolios,
  toPrivacy,
  toProjects,
  toTerms,
} from "@/lib/urls";
import { Link } from "react-router";
import { Separator } from "./ui/separator";

const discoverLinks = [
  { to: toPeople(), label: "People" },
  { to: toProjects(), label: "Projects" },
  { to: toPortfolios(), label: "Portfolios" },
  { to: toFundingPools(), label: "Funding Pools" },
];

const aboutLinks = [
  { to: toAbout(), label: "About us" },
  { to: toCareers(), label: "Careers" },
  { to: toFAQ(), label: "FAQ" },
];

const footerLinks = [
  { to: toPrivacy(), label: "Privacy" },
  { to: toTerms(), label: "Terms" },
];

const COEFFICIENT_GIVING_URL = "https://www.coefficientgiving.org";

const Footer = () => {
  return (
    <footer className="border-t py-8 flex flex-col gap-8">
      <div className="w-full max-w-7xl mx-auto px-4 overflow-hidden sm:px-6 lg:px-8 grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-x-8 gap-y-4">
        <div className="flex flex-col gap-6 xs:col-span-2 sm:col-span-1 lg:contents">
          <Link to={toHome()} className="w-fit">
            {/* Solid white on a dark footer (the navy wordmark disappears there). */}
            <img
              src="/images/logo.png"
              alt="Catalyze"
              className="max-h-10 dark:brightness-0 dark:invert"
            />
          </Link>

          <a
            href={COEFFICIENT_GIVING_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="With support from Coefficient Giving"
            className="group flex flex-col gap-2 w-fit lg:col-start-4 lg:row-start-1 lg:justify-self-end"
          >
            <span className="text-sm text-muted-foreground group-hover:underline">
              With support from
            </span>
            <img
              src="/images/coefficient-logo-gray.svg"
              alt="Coefficient Giving"
              className="h-10 w-auto dark:hidden"
            />
            <img
              src="/images/coefficient-logo-white.svg"
              alt=""
              className="h-10 w-auto hidden dark:block"
              aria-hidden="true"
            />
          </a>
        </div>

        <div className="flex flex-col gap-1">
          <h3 className="text-sm text-muted-foreground">Explore</h3>
          {discoverLinks.map((link) => (
            <Link key={link.to} to={link.to} className="w-fit hover:underline">
              {link.label}
            </Link>
          ))}
        </div>

        <div className="flex flex-col gap-1">
          <h3 className="text-sm text-muted-foreground">About</h3>
          {aboutLinks.map((link) => (
            <Link key={link.to} to={link.to} className="w-fit hover:underline">
              {link.label}
            </Link>
          ))}
        </div>
      </div>

      <Separator />

      <div className="max-w-7xl mx-auto px-4 overflow-hidden sm:px-6 lg:px-8 flex gap-6 justify-center items-center text-sm">
        <p className="text-muted-foreground">
          Catalyze R&D, LLC &copy; {new Date().getFullYear()}
        </p>
        {footerLinks.map((link) => (
          <Link key={link.to} to={link.to} className="hover:underline">
            {link.label}
          </Link>
        ))}
      </div>
    </footer>
  );
};

export default Footer;
